import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';

// Google's wordmark is a bitmap, so it is served from the assets host rather than bundled. Width and
// height are set explicitly to reserve space while it loads.
const GOOGLE_WORD_LOGO_IMAGE = 'https://withjoy.com/assets/public/apps/shared/google-word-logo.png';

export const PoweredByGoogle: React.FC = () => {
  return (
    <Flex
      justifyContent={'flex-end'}
      padding={3}
    >
      {/* Not translated — must remain in English per Google branding guidelines */}
      <TextV2 typographyVariant={'label1'}>Powered by</TextV2>
      <Flex __css={{ '& > img': { paddingBottom: '3px' } }}>
        <img
          src={GOOGLE_WORD_LOGO_IMAGE}
          alt="Google"
          width={60}
          height={19}
        />
      </Flex>
    </Flex>
  );
};
